<template>
  <a-select
    v-model:value="value"
    show-search
    style="width: 100%"
    :default-active-first-option="false"
    :show-arrow="false"
    :allowClear="true"
    :filter-option="false"
    :not-found-content="null"
    :options="suggestionData"
    @search="search"
    @change="onChange"
    :disabled="disabled"
  ></a-select>
</template>
<script lang='ts' setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'
import { message } from 'ant-design-vue';

let _searchDebounce: any = null

const suggestionData: any = ref([])

const props = defineProps({
  modelValue: {
    type: String,
  },
  name: {
    type: String,
  },
  isStrict: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
})
const emits = defineEmits(['update:modelValue', 'changeValues'])
onMounted(() => {
  search('')
})
const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})

watch(props, (newVal) => {
  console.log(123123123, newVal.modelValue);
  
  if (newVal.modelValue) {

    if (!suggestionData.value.length || !suggestionData.value.find(v=>v.value==newVal.modelValue)) {
      request.get(`/api/users`, {
        username: newVal.name,
        limit: 100,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.list) {
          suggestionData.value.push({
            label: v.username,
            value: v.id
          })
        }
      })
    }
  }
})

const search = (name) => {
  clearTimeout(_searchDebounce)
  _searchDebounce =  setTimeout(() => {
      request.get(`/api/users`, {
        username: name,
        limit: 100,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.list) {
          suggestionData.value.push({
            label: v.username,
            value: v.id
          })
        }
      })
    }, 600)
  
}

const onChange = (item, options) => {
  console.log(item, options);
  if (options) {
    emits('changeValues', {director_name: options.label})
    emits('update:modelValue', options.value)
  }
}
</script>
<style lang='scss' scoped>

</style>